type Order = "asc" | "desc";
type KeysWithValsOfType<Source, ValType> = {
  [K in keyof Source]-?: Source[K] extends ValType ? K : never;
}[keyof Source];
type SortableKey<ObjectType> = KeysWithValsOfType<Required<ObjectType>, number | string>;

/* eslint-disable class-methods-use-this */
class SortingService {
  protected descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  public getComparator<O>(order: Order, orderBy: SortableKey<O>): (a: O, b: O) => number {
    return order === "desc"
      ? (a, b) => this.descendingComparator(a, b, orderBy)
      : (a, b) => -this.descendingComparator(a, b, orderBy);
  }

  public stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
    const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
}
export default SortingService;
